
document.getElementById('buy-now-button').addEventListener('click', function() {
  // Perform AJAX request to clear the cart and add the product
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function(response) {
    // Check if cart cleared successfully
    if (response.ok) {
      // Get the product form
      var form = document.querySelector('form[action="/cart/add"]');
      
      // Serialize form data
      var formData = new FormData(form);
      var formParams = new URLSearchParams(formData).toString();
      
      // Add the product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formParams
      }).then(function(response) {
        // Check if product added successfully
        if (response.ok) {
          // Redirect to checkout
          window.location.href = '/checkout';
        } else {
          console.error('Error adding product to cart:', response);
          alert('Error adding product to cart. Please try again.');
        }
      }).catch(function(error) {
        console.error('Error adding product to cart:', error);
        alert('Error adding product to cart. Please try again.');
      });
    } else {
      console.error('Error clearing cart:', response);
      alert('Error clearing cart. Please try again.');
    }
  }).catch(function(error) {
    console.error('Error clearing cart:', error);
    alert('Error clearing cart. Please try again.');
  });
});

